import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import orderBluBarActive from '../../assets/img/order_blu_bar_active.png';
import orderBluBarInactive from '../../assets/img/order_blu_bar_inactive.png';
import orderTobaccoActive from '../../assets/img/order_tobacco_active.png';
import orderTobaccoInactive from '../../assets/img/order_tobacco_inactive.png';

import './new-order-tabs.css';

class NewOrderTabs extends Component {
  render() {
    const { selectedTab, tab, onTabSelect } = this.props;
    const isTobaccoActive = selectedTab === tab.tobacco;
    const isBluBar = selectedTab === tab.bluBar;

    return(
      <div className="order-tab-container">
        <div className="order-tab-info">
          Click on either of the tabs below to add blu bar and tobacco products to your basket.
        </div>
        <br />
        <Button
          className="order-tab"
          onClick={() => onTabSelect(tab.tobacco)}
        >
          <img src={isTobaccoActive ? orderTobaccoActive : orderTobaccoInactive} width={400} height={115} />
        </Button>
        <Button
          className="order-tab"
          onClick={() => onTabSelect(tab.bluBar)}
        >
          <img src={isBluBar ? orderBluBarActive : orderBluBarInactive} width={400} height={115}  />
        </Button>
      </div>
    );
  }
}

export default NewOrderTabs;



// WEBPACK FOOTER //
// ./src/components/new-order/new-order-tabs.jsx